import { FlexBox, FormField, Text } from '@dixa/lib-shared-habla';
import { Control, FieldValues, Path } from 'react-hook-form';

import { FieldInputText } from './fieldInputText';

type ColumnSpan = 1 | 2 | 3 | 4 | 5;
type FieldInputTextInlineProps<T extends FieldValues> = {
  control: Control<T>;
  fieldName: Path<T>;
  label: string;
  spans?: {
    left: ColumnSpan;
  };
};
/**
 * `FieldInputTextInline` is a component that must be used within a `FormGrid`
 * component in order for the layout to work.
 */
export function FieldInputTextInline<T extends FieldValues>({
  control,
  fieldName,
  label,
  spans = {
    left: 2,
  },
}: FieldInputTextInlineProps<T>): JSX.Element {
  return (
    <>
      <FormField span={spans.left}>
        <FlexBox alignItems="start" margin="11px 0 0">
          <Text.Paragraph variant="3" subdued>
            {label}
          </Text.Paragraph>
        </FlexBox>
      </FormField>
      <FormField span={(6 - spans.left) as ColumnSpan}>
        <FieldInputText control={control} name={fieldName} />
      </FormField>
    </>
  );
}
